// extracted by mini-css-extract-plugin
module.exports = {"noTouchAction":"shared_noTouchAction__FSFOx","touchActionPanX":"shared_touchActionPanX__xQ3ls"};